export const INPUT_WRAPPER_MIN_WIDTH = "20px";
export const INPUT_WRAPPER_MIN_HEIGHT = "20px";

export const INPUT_HEIGHT = "18px";
export const INPUT_WIDTH = "18px";
